module.exports = "/images/b5430be-group_management.png";